var Backbone, SupportFinePrintPresenterPresentation, SupportFinePrintTemplate, SupportFinePrintView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportFinePrintPresenterPresentation = require('../../presenters/fine_print_presenter');

Backbone = require('backbone');

Backbone.$ = $;

SupportFinePrintTemplate = require('../../../fine_print.html.mustache');

SupportFinePrintView = (function(superClass) {
  extend(SupportFinePrintView, superClass);

  function SupportFinePrintView() {
    return SupportFinePrintView.__super__.constructor.apply(this, arguments);
  }

  SupportFinePrintView.prototype.id = 'viewPopupContent';

  SupportFinePrintView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    return this.template = SupportFinePrintTemplate;
  };

  SupportFinePrintView.prototype.render = function() {
    this.popup = $('#popup');
    GIG.Modal.open({
      el: this.popup,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
    this.popup.html(this.el);
    return openLinksInNewTab($('#popupContent a'));
  };

  SupportFinePrintView.prototype.toHash = function() {
    var ref;
    return {
      fine_print: Groupon.Support.currentOrder.finePrintText || ((ref = Groupon.Support.currentOrder.deal) != null ? ref.finePrintText : void 0)
    };
  };

  SupportFinePrintView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  SupportFinePrintView.prototype.events = {
    'click .close-modal': "closeModal"
  };

  return SupportFinePrintView;

})(Backbone.View);

module.exports = SupportFinePrintView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9vcmRlcl9yZWxhdGVkL2ZpbmVfcHJpbnRfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9rdW1hcnJhL25hcGlzdHJhbm8vYnVpbGQvMTUwNDc3ODE0MzUyNi03NjE3Ny9wcm9kdWN0aW9uLTIwMTcuMDkuMDdfMDkuNTQvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ZpZXdzL29yZGVyX3JlbGF0ZWQvZmluZV9wcmludF92aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLCtGQUFBO0VBQUE7OztBQUFBLHFDQUFBLEdBQXdDLE9BQUEsQ0FBUSx1Q0FBUjs7QUFDeEMsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBQ2Isd0JBQUEsR0FBMkIsT0FBQSxDQUFRLG1DQUFSOztBQUVyQjs7Ozs7OztpQ0FDSixFQUFBLEdBQUk7O2lDQUVKLFVBQUEsR0FBWSxTQUFBO0lBQ1YsSUFBQyxDQUFBLFNBQUQsR0FBYTtXQUNiLElBQUMsQ0FBQSxRQUFELEdBQVk7RUFGRjs7aUNBSVosTUFBQSxHQUFRLFNBQUE7SUFDTixJQUFDLENBQUEsS0FBRCxHQUFTLENBQUEsQ0FBRSxRQUFGO0lBQ1QsR0FBRyxDQUFDLEtBQUssQ0FBQyxJQUFWLENBQ0U7TUFBQSxFQUFBLEVBQUksSUFBQyxDQUFBLEtBQUw7TUFDQSxjQUFBLEVBQWdCLElBRGhCO01BRUEsYUFBQSxFQUFlLElBRmY7S0FERjtJQUtBLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLE1BQUEsQ0FBTyxJQUFDLENBQUEsUUFBUixFQUFrQixJQUFDLENBQUEsTUFBRCxDQUFBLENBQWxCLEVBQTZCLElBQUMsQ0FBQSxTQUE5QixDQUFWO0lBQ0EsSUFBQyxDQUFBLEtBQUssQ0FBQyxJQUFQLENBQVksSUFBSSxDQUFDLEVBQWpCO1dBQ0EsaUJBQUEsQ0FBa0IsQ0FBQSxDQUFFLGlCQUFGLENBQWxCO0VBVE07O2lDQVdSLE1BQUEsR0FBUSxTQUFBO0FBQ04sUUFBQTtXQUFBO01BQUEsVUFBQSxFQUFZLE9BQU8sQ0FBQyxPQUFPLENBQUMsWUFBWSxDQUFDLGFBQTdCLDREQUErRSxDQUFFLHVCQUE3Rjs7RUFETTs7aUNBR1IsVUFBQSxHQUFZLFNBQUE7SUFDVixHQUFHLENBQUMsS0FBSyxDQUFDLEtBQVYsQ0FBQTtBQUNBLFdBQU87RUFGRzs7aUNBSVosTUFBQSxHQUNFO0lBQUEsb0JBQUEsRUFBdUIsWUFBdkI7Ozs7O0dBMUIrQixRQUFRLENBQUM7O0FBNEI1QyxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
